export default "__VITE_ASSET__Blj6TcMB__"